"use strict";

var _regeneratorRuntime = require("/opt/buildhome/repo/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthenticationManager = void 0;

var Endpoints_1 = require("../Endpoints");

var cross_fetch_1 = __importDefault(require("cross-fetch"));

exports.AuthenticationManager = {
  login: function login(credentials) {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response, token;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, cross_fetch_1.default)(Endpoints_1.Endpoints.login, {
                body: JSON.stringify(credentials)
              });

            case 2:
              response = _context.sent;
              token = response.headers.get('set-cookie');

              if (!(!token || !token[0])) {
                _context.next = 6;
                break;
              }

              throw new Error('Error fetching token for login.');

            case 6:
              return _context.abrupt("return", token);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  }
};